export const PRIVACY_POLICY_URL = 'https://www.fleetback.com/privacy-policy';

export const CookieEnum = {
  ESSENTIAL: 'ESSENTIAL',
  ANALYTICS: 'ANALYTICS'
} as const;

type CookieEnum = (typeof CookieEnum)[keyof typeof CookieEnum];

export const DEFAULT_COOKIE_PREFERENCES: Record<CookieEnum, boolean> = {
  [CookieEnum.ESSENTIAL]: true,
  [CookieEnum.ANALYTICS]: false,
};
